// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-" + "f5d0fddb3b6393457e7b" + ".chunk.js";
};